/* global axios */
import ApiClient from './ApiClient';

class RefundsAPI extends ApiClient {
  constructor() {
    super('conversations', { accountScoped: true });
  }

  undo(conversationId) {
    return axios.delete(`${this.url}/${conversationId}/refund`);
  }
}

export default new RefundsAPI();
